import { Component, OnInit, TemplateRef, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from '../../../environments/environment'
import { StoreService } from '../../service/store.service'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { debug, isNullOrUndefined } from 'util'
import { CompanyStructureTableComponent } from '../company-structure-table/company-structure-table.component'

@Component({
  selector: 'app-company-structure-picture',
  templateUrl: './company-structure-picture.component.html',
  styleUrls: ['./company-structure-picture.component.scss']
})
export class CompanyStructurePictureComponent implements OnInit, OnDestroy {
  @Input() printPage
  @Input() isFullFactSheet
  @Input() calluploadFunction: Map<String, Function>
  @Output() flagPicChange: EventEmitter<any> = new EventEmitter()
  @ViewChild(CompanyStructureTableComponent)
  companyStructureTableComponent: CompanyStructureTableComponent
  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('templateDel') templateDel: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  listTable = []
  listItem = []
  listDelete = []
  listAdd = []
  checkSubmit = false
  iframeSource

  message
  symbol
  dataType = 'CompStructure'
  subscription: Subscription
  companyIdPsims
  companyStructureFilename
  securitySymbol
  oldSecuritySymbol
  totalPages
  isLoaded
  page
  showData = false
  editFlag = false
  previewElement

  constructor(
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnDestroy() {
    this.previewElement = null
  }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        if (!this.oldSecuritySymbol || this.oldSecuritySymbol !== response['securitySymbol']) {
          this.previewElement = null
        }
        this.companyIdPsims = response['companyIdPsims']
        this.securitySymbol = response['securitySymbol']
        this.oldSecuritySymbol = this.securitySymbol
        this.companyStructureFilename = response['companyStructureFilename']
        if (!isNullOrUndefined(this.companyIdPsims)) {
          this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
            `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${
            response['companyIdPsims']
            }`
          )
        }
      })
  }

  getLink(companyIdPsims) {
    if (!this.previewElement) {
      this.previewElement = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${companyIdPsims}`
      );
      return this.previewElement;
    } else {
      return this.previewElement;
    }
  }

  testClick(symbol) {
    this.companyStructureFilename = symbol
    this.checkSubmit = true
    this.previewElement = null
  }

  getResponeUpload($event) {
    this.flagPicChange.emit(true)
  }

  emptyCompanyFilename() {
    return (this.companyStructureFilename === null || this.companyStructureFilename === '')
  }

  checkFileType() {
    const fileType: String = String(this.companyStructureFilename)
    const pdfType: Boolean = fileType.endsWith('.pdf')

    if (pdfType === true) {
      return true
    } else {
      return false
    }
  }

  fileUpload() {
    const width = 600
    const height = 600
    const left = screen.width / 2 - width / 2
    const top = screen.height / 2 - height / 2
    this.openModal(this.template)
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
    this.flagPicChange.emit(true)
  }

  closeModal() {
    this.modalRef.hide()
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages
    this.isLoaded = true
  }
  nextPage() {
    this.page++
  }

  prevPage() {
    this.page--
  }

  get isiframe() {
    return !(this.printPage && this.checkFileType)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-structure-picture/company-structure-picture.component.ts